<template>
  <g>
    <rect v-for="(line, index) in lines"
      :key="'line-'+index"
      :x="line.x"
      :y="line.y"
      :height="height"
      :width="lineWidth"
      :fill="lineColor(index)"
      :stroke-width="strokeWidth"
      :stroke="stroke"
      :opacity="opacity"
      @mouseover="onMouseover($event, line, index)"
      @mouseleave="onMouseleave()"
    />
  </g>
</template>

<script>
// multiplier to help positioning the tooltip horizontally
// close to the bar without cover it.
const TRANSLATE_FACTOR = 3.5;

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    xScale: {
      type: Function,
      required: true,
    },
    dimensionKey: {
      type: String,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    lineWidth: {
      type: Number,
      default: 1,
    },
    color: {
      type: String,
      default: '#C1CCD4',
    },
    strokeWidth: {
      type: Number,
      default: 8,
    },
    opacity: {
      type: Number,
      default: 0.5,
    },
    stroke: {
      type: String,
      default: 'transparent',
    },
    hoveredIndex: {
      type: Number,
    },
  },
  computed: {
    lines() {
      return this.data.map(d => {
        const baseObj = {};

        baseObj.d = d;
        baseObj.y = 0;
        baseObj.x = this.xScale(d[this.dimensionKey]) - .5;

        return baseObj;

      });
    },
  },
  methods: {
    onMouseover(event, line, index) {
      this.$emit('onHover', {
        data: {
          d: line.d,
        },
        hoveredIndex: index,
        position: {
          left: line.x + TRANSLATE_FACTOR*(this.lineWidth + this.strokeWidth),
          top: event.offsetY,
        },
      });
    },
    onMouseleave() {
      this.$emit('onLeave');
    },
    lineColor(index) {
      return this.hoveredIndex === index ? this.color : 'transparent';
    },
  },
};
</script>
